// // import React, { useState, useEffect, useRef } from "react";

// // const ICON_BASE = `${process.env.NEXT_PUBLIC_FRONTEND_URL}/static/img/icons`;

// // const features = [
// //   {
// //     icon: `${ICON_BASE}/icon-shipping.webp`,
// //     title: "Schnelle Lieferung",
// //   },
// //   {
// //     icon: `${ICON_BASE}/icon-trusted-brands.webp`,
// //     title: "Vertraute Marken",
// //   },
// //   {
// //     icon: `${ICON_BASE}/icon-support.webp`,
// //     title: "24/7 Kundenservice",
// //   },
// //   {
// //     icon: `${ICON_BASE}/icon-savings.webp`,
// //     title: "Sparvorteile sichern",
// //   },
// // ];

// // const chunk = (arr, size) => {
// //   const result = [];
// //   for (let i = 0; i < arr.length; i += size) {
// //     result.push(arr.slice(i, i + size));
// //   }
// //   return result;
// // };

// // const FeatureItem = ({ feature, isMobile }) => (
// //   <div
// //     style={{
// //       display: "flex",
// //       alignItems: "center",
// //       justifyContent: "center",
// //       flex: isMobile ? undefined : 1,
// //       minWidth: 0,
// //       maxWidth: isMobile ? "100%" : undefined,
// //       boxSizing: "border-box",
// //       gap: isMobile ? 6 : 12,
// //       padding: isMobile ? "12px 6px" : "18px 20px",
// //     }}
// //   >
// //     <div
// //       style={{
// //         flexShrink: 0,
// //         width: isMobile ? 20 : 26,
// //         height: isMobile ? 20 : 26,
// //         display: "flex",
// //         alignItems: "center",
// //         justifyContent: "center",
// //         userSelect: "none",
// //       }}
// //     >
// //       <img
// //         src={feature.icon}
// //         alt=""
// //         width={isMobile ? 20 : 26}
// //         height={isMobile ? 20 : 26}
// //         loading="lazy"
// //         style={{
// //           width: isMobile ? 20 : 26,
// //           height: isMobile ? 20 : 26,
// //           objectFit: "contain",
// //         }}
// //       />
// //     </div>
// //     <span
// //       style={{
// //         fontSize: isMobile ? 14 : 16,
// //         fontWeight: 600,
// //         color: "#1e293b",
// //         lineHeight: 1.25,
// //         textAlign: "left",
// //         whiteSpace: isMobile ? "normal" : "normal",
// //         wordBreak: isMobile ? "break-word" : "normal",
// //         minWidth: 0,
// //       }}
// //     >
// //       {feature.title}
// //     </span>
// //   </div>
// // );

// // const SiteFeatures = () => {
// //   const [screenSize, setScreenSize] = useState("desktop");
// //   const [activePage, setActivePage] = useState(0);
// //   const trackRef = useRef(null);

// //   useEffect(() => {
// //     const updateSize = () => {
// //       const width = window.innerWidth;
// //       if (width < 768) setScreenSize("mobile");
// //       else if (width < 1024) setScreenSize("tablet");
// //       else setScreenSize("desktop");
// //     };
// //     updateSize();
// //     window.addEventListener("resize", updateSize);
// //     return () => window.removeEventListener("resize", updateSize);
// //   }, []);

// //   const isMobile = screenSize === "mobile";
// //   const pages = chunk(features, 2);

// //   const handleScroll = () => {
// //     if (!trackRef.current) return;
// //     const { scrollLeft, clientWidth } = trackRef.current;
// //     const page = Math.round(scrollLeft / clientWidth);
// //     setActivePage(page);
// //   };

// //   const scrollToPage = (index) => {
// //     if (!trackRef.current) return;
// //     trackRef.current.scrollTo({
// //       left: index * trackRef.current.clientWidth,
// //       behavior: "smooth",
// //     });
// //   };

// //   if (!isMobile) {
// //     return (
// //       <div>
// //         <div
// //           style={{
// //             margin: "0 auto",
// //             display: "flex",
// //             flexDirection: "row",
// //             alignItems: "stretch",
// //             justifyContent: "space-around",
// //           }}
// //         >
// //           {features.map((feature, index) => (
// //             <FeatureItem key={index} feature={feature} isMobile={false} />
// //           ))}
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div style={{ maxWidth: 1200, margin: "0 auto", overflow: "hidden" }}>
// //       <div
// //         ref={trackRef}
// //         onScroll={handleScroll}
// //         style={{
// //           display: "flex",
// //           overflowX: "auto",
// //           scrollSnapType: "x mandatory",
// //           WebkitOverflowScrolling: "touch",
// //           scrollbarWidth: "none",
// //         }}
// //       >
// //         {pages.map((pageItems, pageIndex) => (
// //           <div
// //             key={pageIndex}
// //             style={{
// //               flex: "0 0 100%",
// //               minWidth: 0,
// //               width: "100%",
// //               boxSizing: "border-box",
// //               overflow: "hidden",
// //               scrollSnapAlign: "start",
// //               scrollSnapStop: "always",
// //               display: "flex",
// //               justifyContent: "center",
// //               alignItems: "center",
// //             }}
// //           >
// //             <div
// //               style={{
// //                 display: "grid",
// //                 gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
// //                 justifyItems: "center",
// //                 justifyContent: "center",
// //                 width: "100%",
// //                 maxWidth: 400,
// //                 boxSizing: "border-box",
// //               }}
// //             >
// //               {pageItems.map((feature, i) => (
// //                 <FeatureItem key={i} feature={feature} isMobile={true} />
// //               ))}
// //             </div>
// //           </div>
// //         ))}
// //       </div>

// //       {pages.length > 1 && (
// //         <div
// //           style={{
// //             display: "flex",
// //             justifyContent: "center",
// //             gap: 6,
// //             marginTop: 8,
// //           }}
// //         >
// //           {pages.map((_, index) => (
// //             <button
// //               key={index}
// //               onClick={() => scrollToPage(index)}
// //               aria-label={`Seite ${index + 1}`}
// //               style={{
// //                 width: 6,
// //                 height: 6,
// //                 borderRadius: "50%",
// //                 border: "none",
// //                 padding: 0,
// //                 background: activePage === index ? "#1e293b" : "#cbd5e1",
// //                 cursor: "pointer",
// //               }}
// //             />
// //           ))}
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default SiteFeatures;



// import React, { useState, useEffect, useRef } from "react";

// const ICON_BASE = `${process.env.NEXT_PUBLIC_FRONTEND_URL}/static/img/icons`;

// const features = [
//   { icon: `${ICON_BASE}/icon-shipping.webp`, title: "Schnelle Lieferung" },
//   { icon: `${ICON_BASE}/icon-trusted-brands.webp`, title: "Vertraute Marken" },
//   { icon: `${ICON_BASE}/icon-support.webp`, title: "24/7 Kundenservice" },
//   { icon: `${ICON_BASE}/icon-savings.webp`, title: "Sparvorteile sichern" },
// ];

// const chunk = (arr, size) => {
//   const result = [];
//   for (let i = 0; i < arr.length; i += size) {
//     result.push(arr.slice(i, i + size));
//   }
//   return result;
// };

// const FeatureItem = ({ feature }) => (
//   <div className="rw-site-features__item">
//     <div className="rw-site-features__icon">
//       <img src={feature.icon} alt="" loading="lazy" />
//     </div>
//     <span className="rw-site-features__title">{feature.title}</span>
//   </div>
// );

// const SiteFeatures = () => {
//   const [isMobile, setIsMobile] = useState(false);
//   const [activePage, setActivePage] = useState(0);
//   const trackRef = useRef(null);

//   useEffect(() => {
//     const updateSize = () => setIsMobile(window.innerWidth < 768);
//     updateSize();
//     window.addEventListener("resize", updateSize);
//     return () => window.removeEventListener("resize", updateSize);
//   }, []);

//   const pages = chunk(features, 2);

//   const handleScroll = () => {
//     if (!trackRef.current) return;
//     const { scrollLeft, clientWidth } = trackRef.current;
//     setActivePage(Math.round(scrollLeft / clientWidth));
//   };

//   const scrollToPage = (index) => {
//     if (!trackRef.current) return;
//     trackRef.current.scrollTo({
//       left: index * trackRef.current.clientWidth,
//       behavior: "smooth",
//     });
//   };

//   return (
//     <section className="rw-site-features">
//       <div className="rw-site-features__inner">
//         {!isMobile ? (
//           <div className="rw-site-features__row">
//             {features.map((feature) => (
//               <FeatureItem key={feature.title} feature={feature} />
//             ))}
//           </div>
//         ) : (
//           <>
//             <div
//               ref={trackRef}
//               onScroll={handleScroll}
//               className="rw-site-features__track"
//             >
//               {pages.map((pageItems, pageIndex) => (
//                 <div key={pageIndex} className="rw-site-features__page">
//                   <div className="rw-site-features__grid">
//                     {pageItems.map((feature) => (
//                       <FeatureItem key={feature.title} feature={feature} />
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {pages.length > 1 && (
//               <div className="rw-site-features__dots">
//                 {pages.map((_, index) => (
//                   <button
//                     key={index}
//                     type="button"
//                     onClick={() => scrollToPage(index)}
//                     aria-label={`Seite ${index + 1}`}
//                     className={`rw-site-features__dot${
//                       activePage === index
//                         ? " rw-site-features__dot--active"
//                         : ""
//                     }`}
//                   />
//                 ))}
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       <style jsx global>{`
//         .rw-site-features {
//           background: var(--search-bg) !important;
//           /* volle Breite, auch wenn der Parent einen Container/Padding hat */
//           width: 100vw;
//           margin-left: calc(50% - 50vw);
//         }
//         .rw-site-features__inner {
//           max-width: 1200px;
//           margin: 0 auto;
//           overflow: hidden;
//         }
//         .rw-site-features__row {
//           display: flex;
//           flex-direction: row;
//           align-items: stretch;
//           justify-content: space-around;
//         }
//         .rw-site-features__item {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           flex: 1;
//           min-width: 0;
//           box-sizing: border-box;
//           gap: 12px;
//           padding: 18px 20px;
//         }
//         .rw-site-features__icon {
//           flex-shrink: 0;
//           width: 26px;
//           height: 26px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           user-select: none;
//         }
//         .rw-site-features__icon img {
//           width: 26px;
//           height: 26px;
//           object-fit: contain;
//         }
//         .rw-site-features__title {
//           font-size: 16px;
//           font-weight: 600;
//           color: #1e293b;
//           line-height: 1.25;
//           text-align: left;
//           min-width: 0;
//         }

//         /* Mobile Carousel */
//         .rw-site-features__track {
//           display: flex;
//           overflow-x: auto;
//           scroll-snap-type: x mandatory;
//           -webkit-overflow-scrolling: touch;
//           scrollbar-width: none;
//         }
//         .rw-site-features__track::-webkit-scrollbar {
//           display: none;
//         }
//         .rw-site-features__page {
//           flex: 0 0 100%;
//           min-width: 0;
//           width: 100%;
//           box-sizing: border-box;
//           overflow: hidden;
//           scroll-snap-align: start;
//           scroll-snap-stop: always;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//         }
//         .rw-site-features__grid {
//           display: grid;
//           grid-template-columns: repeat(2, minmax(0, 1fr));
//           justify-items: center;
//           justify-content: center;
//           width: 100%;
//           max-width: 400px;
//           box-sizing: border-box;
//         }
//         .rw-site-features__grid .rw-site-features__item {
//           flex: none;
//           max-width: 100%;
//           gap: 6px;
//           padding: 12px 6px;
//         }
//         .rw-site-features__grid .rw-site-features__icon,
//         .rw-site-features__grid .rw-site-features__icon img {
//           width: 20px;
//           height: 20px;
//         }
//         .rw-site-features__grid .rw-site-features__title {
//           font-size: 14px;
//           word-break: break-word;
//         }
//         .rw-site-features__dots {
//           display: flex;
//           justify-content: center;
//           gap: 6px;
//           padding: 8px 0;
//         }
//         .rw-site-features__dot {
//           width: 6px;
//           height: 6px;
//           border-radius: 50%;
//           border: none;
//           padding: 0;
//           background: #cbd5e1;
//           cursor: pointer;
//         }
//         .rw-site-features__dot--active {
//           background: #1e293b;
//         }
//       `}</style>
//     </section>
//   );
// };

// export default SiteFeatures;


import React, { useState, useEffect, useRef } from "react";

const ICON_BASE = `${process.env.NEXT_PUBLIC_FRONTEND_URL}/static/img/icons`;

const features = [
  { icon: `${ICON_BASE}/icon-shipping.webp`, title: "Schnelle Lieferung" },
  { icon: `${ICON_BASE}/icon-trusted-brands.webp`, title: "Vertraute Marken" },
  { icon: `${ICON_BASE}/icon-support.webp`, title: "24/7 Kundenservice" },
  { icon: `${ICON_BASE}/icon-savings.webp`, title: "Sparvorteile sichern" },
];

const chunk = (arr, size) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

const FeatureItem = ({ feature }) => (
  <div className="rw-site-features__item">
    <div className="rw-site-features__icon">
      <img src={feature.icon} alt="" loading="lazy" />
    </div>
    <span className="rw-site-features__title">{feature.title}</span>
  </div>
);

const SiteFeatures = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [activePage, setActivePage] = useState(0);
  const trackRef = useRef(null);

  useEffect(() => {
    const updateSize = () => setIsMobile(window.innerWidth < 768);
    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const pages = chunk(features, 2);

  const handleScroll = () => {
    if (!trackRef.current) return;
    const { scrollLeft, clientWidth } = trackRef.current;
    setActivePage(Math.round(scrollLeft / clientWidth));
  };

  const scrollToPage = (index) => {
    if (!trackRef.current) return;
    trackRef.current.scrollTo({
      left: index * trackRef.current.clientWidth,
      behavior: "smooth",
    });
  };

  return (
    <section className="rw-site-features">
      {!isMobile ? (
        <div className="rw-site-features__row">
          {features.map((feature) => (
            <FeatureItem key={feature.title} feature={feature} />
          ))}
        </div>
      ) : (
        <div className="rw-site-features__mobile">
          <div
            ref={trackRef}
            onScroll={handleScroll}
            className="rw-site-features__track"
          >
            {pages.map((pageItems, pageIndex) => (
              <div key={pageIndex} className="rw-site-features__page">
                <div className="rw-site-features__grid">
                  {pageItems.map((feature) => (
                    <FeatureItem key={feature.title} feature={feature} />
                  ))}
                </div>
              </div>
            ))}
          </div>

          {pages.length > 1 && (
            <div className="rw-site-features__dots">
              {pages.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => scrollToPage(index)}
                  aria-label={`Seite ${index + 1}`}
                  className={`rw-site-features__dot${
                    activePage === index
                      ? " rw-site-features__dot--active"
                      : ""
                  }`}
                />
              ))}
            </div>
          )}
        </div>
      )}

      <style jsx global>{`
        .rw-site-features {
          position: relative;
        }
        /* Hintergrund über die volle Breite, Inhalt behält seine Breite */
        .rw-site-features::before {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          left: 50%;
          width: 100vw;
          margin-left: -50vw;
          background: var(--search-bg) !important;
          z-index: 0;
        }

        /* Desktop / Tablet */
        .rw-site-features__row {
          position: relative;
          z-index: 1;
          margin: 0 auto;
          display: flex;
          flex-direction: row;
          align-items: stretch;
          justify-content: space-around;
        }
        .rw-site-features__item {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
          min-width: 0;
          box-sizing: border-box;
          gap: 12px;
          padding: 18px 20px;
        }
        .rw-site-features__icon {
          flex-shrink: 0;
          width: 26px;
          height: 26px;
          display: flex;
          align-items: center;
          justify-content: center;
          user-select: none;
        }
        .rw-site-features__icon img {
          width: 26px;
          height: 26px;
          object-fit: contain;
        }
        .rw-site-features__title {
          font-size: 16px;
          font-weight: 600;
          color: #1e293b;
          line-height: 1.25;
          text-align: left;
          min-width: 0;
        }

        /* Mobile Carousel */
        .rw-site-features__mobile {
          position: relative;
          z-index: 1;
          max-width: 1200px;
          margin: 0 auto;
          overflow: hidden;
        }
        .rw-site-features__track {
          display: flex;
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
        }
        .rw-site-features__track::-webkit-scrollbar {
          display: none;
        }
        .rw-site-features__page {
          flex: 0 0 100%;
          min-width: 0;
          width: 100%;
          box-sizing: border-box;
          overflow: hidden;
          scroll-snap-align: start;
          scroll-snap-stop: always;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .rw-site-features__grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          justify-items: center;
          justify-content: center;
          width: 100%;
          max-width: 400px;
          box-sizing: border-box;
        }
        .rw-site-features__grid .rw-site-features__item {
          flex: none;
          max-width: 100%;
          gap: 6px;
          padding: 12px 6px;
        }
        .rw-site-features__grid .rw-site-features__icon,
        .rw-site-features__grid .rw-site-features__icon img {
          width: 20px;
          height: 20px;
        }
        .rw-site-features__grid .rw-site-features__title {
          font-size: 14px;
          word-break: break-word;
        }
        .rw-site-features__dots {
          display: flex;
          justify-content: center;
          gap: 6px;
          margin-top: 8px;
        }
        .rw-site-features__dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          border: none;
          padding: 0;
          background: #cbd5e1;
          cursor: pointer;
        }
        .rw-site-features__dot--active {
          background: #1e293b;
        }
      `}</style>
    </section>
  );
};

export default SiteFeatures;